import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FolderUser.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "FolderUserIcon";
const n = o;
export {
  n as FolderUser,
  o as FolderUserIcon
};
